/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* COMMENTING OUT BECAUSE IT CAUSES AN ERROR
const { run } = require("node:test");
*/

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  if( variant.inventory_quantity < 1 ){
    $('label.block-'+variant.id).addClass('ctmSold');
  }
  else{
    $('label.block-'+variant.id).removeClass('ctmSold');
  }
});


function calcBlanketDiscount() {
  var title, count = 0;
  if ($('body.template-cart').length > 0) {
    $('.Cart__ItemList .CartItem').each(function(){
      title = $(this).find('.CartItem__Title a').data('swaddle');
      if (title == 'swaddles') {
        count ++;
      }
    });
    if (count >= 2) {
      $('.Cart__ItemList .CartItem').each(function(){
        title = $(this).find('.CartItem__Title a').data('swaddle');
        if (title == 'swaddles') {
          var price_html = '';
          if ($(this).find('.CartItem__OriginalPrice.Price').length > 0) {
            price_html = $(this).find('.CartItem__OriginalPrice.Price').html();
          } else {
            price_html = $(this).find('.CartItem__Price.Price').html();
          }
          var price = parseFloat(price_html.replace('$', ''));
          var new_price = price * 0.9;
          $(this).find('.CartItem__LinePriceList').html('<span class="CartItem__Price Price Price--highlight">$'+new_price+'</span><span class="CartItem__OriginalPrice Price Price--compareAt">$'+price+'</span>');
        }
      });
    }
  } else {
    $('#sidebar-cart .CartItemWrapper').each(function(){
      title = $(this).find('.CartItem__Title a').data('swaddle');
      if (title == 'swaddles') {
        count ++;
      }
    });
    if (count >= 2) {
      var new_price_item, new_price_total = 0;
      $('#sidebar-cart .CartItemWrapper').each(function(){
        title = $(this).find('.CartItem__Title a').data('swaddle');
        var price_html = '';
        if ($(this).find('.CartItem__OriginalPrice.Price').length > 0) {
          price_html = $(this).find('.CartItem__OriginalPrice.Price').html();
        } else {
          price_html = $(this).find('.CartItem__Price.Price').html();
        }
        var price = parseFloat(price_html.replace('$', ''));
        if (title == 'swaddles') {
          new_price_item = price * 0.9;
          new_price_total += new_price_item;
          $(this).find('.CartItem__PriceList').html('<span class="CartItem__Price Price Price--highlight">$'+new_price_item+'</span><span class="CartItem__OriginalPrice Price Price--compareAt">$'+price+'</span>');
        } else {
          new_price_total += price;
        }
      });

      $('#sidebar-cart .Drawer__Footer .Button.Cart__Checkout .total').html('$' + new_price_total);
    }
  }
}

var $announcementFlickity;
$(document).ready(function() {

$(document).on('click', '.Drawer__Content .boost-pfs-filter-option-title', function () {
  if(!$(this).hasClass('active')) {
    $('.Drawer__Content .boost-pfs-filter-option-title').removeClass('active');
    $('.Drawer__Content .boost-pfs-filter-option-content').removeClass('active');
    $(this).addClass('active');
    $(this).parent().find('.boost-pfs-filter-option-content').addClass('active');
  } else {
    $('.Drawer__Content .boost-pfs-filter-option-title').removeClass('active');
    $('.Drawer__Content .boost-pfs-filter-option-content').removeClass('active');
  }
});

$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
  $(this).submit();
});
$('.featured__image-with-prodcts .ProductList--carousel').each(function () {
  var option = $(this).data('flickity-config');
  if ($(this).find('.Carousel__Cell').length > 2) {
    $(this).flickity({
      cellAlign: 'left',
      contain: true,
      groupCells: true
    });
  }
})



var rotate_time = $('[data-section-type="announcement-bar"]').data('rotate_time');
var slideIndex = 0; 
showSlides(); // call showslide method 
  
function showSlides() { 
  var i; 

  // get the array of divs' with classname image-sliderfade 
  var slides = document.getElementsByClassName("AnnouncementBar__Content");    

  for (i = 0; i < slides.length; i++) { 
      // initially set the display to  
      // none for every image. 
      slides[i].style.display = "none";  
  } 

  // increase by 1, Global variable 
  slideIndex++;  

  // check for boundary 
  if (slideIndex > slides.length)  
  { 
      slideIndex = 1; 
  } 

  slides[slideIndex - 1].style.display = "block"; 
  setTimeout(showSlides, rotate_time != '' ? Number(rotate_time) : 3000);  
}

$('.modal_link').on('click', function(e){
  e.preventDefault();
  var id = $(this).attr('href');
  $(id).addClass('active');
});

$('.upsell__popup-wrap .item').on('click', function(){
  $('.upsell__popup-wrap .item').each(function(){
    $(this).removeClass('active');
  });
  $(this).addClass('active');
  $('.upsell__popup-wrap .Button').removeClass('Button--secondary').addClass('Button--primary');
  $('.upsell__popup-wrap .add_to_cart').removeClass('disabled');
});

$('.upsell__popup-wrap .add_to_cart').on('click', function(){
  if (!$(this).hasClass('disabled')) {
    var variant_id = $('.upsell__popup-wrap .item.active').data('variant-id');
    var current_variant = {
      id: variant_id
    };
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: 1,
        id: variant_id
      },
      success: function (data) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: current_variant,
            quantity: 1
          }
        }));
        $('.upsell__popup').hide();
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent('product:added_finish'));
        }, 1000);
      }
    });
  }
});

$('.upsell__popup-wrap .close').on('click', function(){
  $('.upsell__popup').hide();
});

$('.PageOverlay').on('click', function(){
  $('.upsell__popup').hide();
});

/*$('.upsell__popup').on('click', function(){
  if ($(window).width() < 600) {
    $(this).css('top', '15%');
  }
});*/

if ($(window).width() < 600) {
  $('.upsell__popup').on('swipeup', function(ev, touch){
    if (!$('.upsell__popup').hasClass('mobile-expanded')) {
      $('.upsell__popup').addClass('mobile-expanded');
    }
  });
  $('.upsell__popup').on('swipedown', function(ev, touch){
    var container_offset = $('.upsell__popup .Grid').offset();
    var elm_offset = $('.upsell__popup .Grid .item:first-child').offset();
    if (elm_offset.top >= container_offset.top) {
      if ($('.upsell__popup').hasClass('mobile-expanded')) {
        $('.upsell__popup').removeClass('mobile-expanded');
      }
    }
  });
}

if ($('#shopify-section-sidebar-menu #sidebar-menu').hasClass('dropdown--menu')) {
  var mobile_menu = $('#shopify-section-sidebar-menu .dropdown--menu .Drawer__Content');
  $('#shopify-section-header #mobile-navation').append(mobile_menu);
  $('#shopify-section-header #section-header [data-drawer-id="sidebar-menu"]').attr('data-action', 'open-dropdownmenu');
  $('#shopify-section-header #section-header [data-drawer-id="sidebar-menu"]').attr('data-drawer-id', 'mobile-navation');
  $('#shopify-section-sidebar-menu .dropdown--menu').remove();
}

$('[data-action="open-dropdownmenu"]').on('click', function (e) {
  e.preventDefault();
  $(this).toggleClass('active');
  if ($('#mobile-navation').attr('aria-hidden') == 'true') {
    $('#mobile-navation').attr('aria-hidden', "false");
    $('body').addClass('block-scroll');
  } else {
    $('#mobile-navation').attr('aria-hidden', "true");
    $('body').removeClass('block-scroll');
  }
});

var slider = $('.sublink-banner');

function flicitySlider() {
  //init flickity
  slider.flickity({
    contain: true,
    imagesLoaded: true,
    cellAlign: 'left',
    cellSelector: '.flickity',
    pageDots: false,
    prevNextButtons: false,
    autoPlay: 2000
  });
}
flicitySlider();

$('.sub-banner-link').mouseover(function () {
  //use data-filter attribute & class for filtering 
  var filterValue = $( this ).attr('data-filter');
  var slide = slider.find('.slide');
  var href = $(this).attr('href');
  $('.sub-banner-link').removeClass('active')
  $(this).addClass('active');
  if (filterValue == 'all') {
    // if all show all
    slide.fadeIn(450);
    slide.addClass('flickity');
  } else {
    //set active slide
    var active = $('.' + filterValue).fadeIn(450);
    $('.' + filterValue).attr('href', href);
    // show only slide with the same class as the button "attr('data-filter')"
    slide.addClass('flickity');
    slide.not(active).removeClass('flickity');
    slide.not(active).hide();
  }

  // destroy slider so we can rebuild with new filters
  slider.flickity('destroy');

  //rebuild slider with new images
  flicitySlider();
  
  // add active class to active button
  $('.MegaMenu__Item .sublink-banner').addClass('active');
});



$(window).scroll(function (e) {
  e.preventDefault();
  if ($('.main-header').hasClass('sticky-header')) {
    if ($(window).scrollTop() < 200) {
      $('.main-header').removeClass('sticky-header');
    }
  } else {
    if ($(window).scrollTop() > 200) {
      $('.main-header').addClass('sticky-header');
    }
  }
});
$.get('//www.cloudflare.com/cdn-cgi/trace', function(data) {
    var country_code = data.replace(/(\r\n|\n|\r)/gm,"").split('loc=');
    country_code = country_code[1].split('tls=');
    country_code = country_code[0];
    if (country_code != 'US') {
      $('.not-US').hide();
    }
  });
});

$(document).ready(function (e) {    
  var current_url = window.location.href;
  var previous_url;
  if (localStorage.getItem("previous_url")) {
    previous_url = localStorage.getItem("previous_url")
  }
  if (current_url == previous_url) {
    if (localStorage.getItem("my_app_name_here-quote-scroll") != null) {
      $(window).scrollTop(localStorage.getItem("my_app_name_here-quote-scroll"));
      localStorage.setItem("my_app_name_here-quote-scroll", 0);
    }
  } else {
    $(window).on("scroll", function() {
      localStorage.setItem("my_app_name_here-quote-scroll", $(window).scrollTop());
    });
  }

  if (document.referrer) {
    localStorage.setItem("previous_url", document.referrer);
  } 

  $('[data-action="goto-link"]').on('click', function (e) {
    e.preventDefault();
    var id = $(this).attr('aria-controls');
    var top = 0;
    if ($(window).width() > 768) {
      top = $('#size').offset().top - 100;
    } else {
      top = $('#mobile-size').offset().top - 300;
    }
    
    $('html, body').animate({
      scrollTop: top
    }, 'slow');
  })

});


/**
* Cookie plugin
*
* Copyright (c) 2006 Klaus Hartl (stilbuero.de)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/**
* Module to show Recently Viewed Products
*
* Copyright (c) 2014 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/

Shopify.Products = (function() {
  var config = { 
    howManyToShow: 3,
    howManyToStoreInMemory: 10, 
    wrapperId: 'recently-viewed-products', 
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };
  
  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function(recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function() {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;        
    },
    destroy: function() {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }       
    }
  };
  
  var finalize = function() {
    wrapper.show();
    $('#recently-viewed-products').flickity($('#recently-viewed-products').data('flickity-config'))
    // If we have a callback.
    if (config.onComplete) {
      try { config.onComplete() } catch (error) { }
    }  
  };
  
  var moveAlong = function() {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function(product) {
          template.tmpl(product).appendTo(wrapper); 
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function() {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    }
    else {
      finalize();
    }
    
  };
  
  return {
   
    resizeImage: function(src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
      } else {
        return null;
      }
    },

    showRecentlyViewed: function(params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();
      
      // Template and element where to insert.
      template = jQuery('#' + config.templateId);
      wrapper = jQuery('#' + config.wrapperId);
      
      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template.length && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();    
      }

    },

    getConfig: function() {
      return config;
    },

    clearList: function() {
      cookie.destroy();      
    },
    
    recordRecentlyViewed: function(params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();
      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        }
        else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);              
        }

        // Update cookie.
        cookie.write(recentlyViewed);

      }
      
    }

  };

})();

Shopify.Products.showRecentlyViewed( { howManyToShow:4 } );

Shopify.Products.recordRecentlyViewed();

// Collection Price Filter 
function initPriceRangeSlider() {
  let priceSliderGroups = document.querySelectorAll('.filter-group-display__price-range');

  priceSliderGroups.forEach((priceSliderGroup) => {
      let priceSlider = priceSliderGroup.querySelector('.price-slider');
      let minRangeInput = priceSliderGroup.querySelector('.min-range');
      let maxRangeInput = priceSliderGroup.querySelector('.max-range');
      let minRangeInputRead = priceSliderGroup.querySelector('.filter-group-display__price-range-to-input--min');
      let maxRangeInputRead = priceSliderGroup.querySelector('.filter-group-display__price-range-to-input--max');
      let rangeMax = maxRangeInput.getAttribute('max');
      let rangeMin = minRangeInput.getAttribute('min');
      updatePriceSlider(rangeMin, rangeMax, priceSliderGroup);

      minRangeInput.addEventListener('input', (e) => {
          let min = e.target.value;
          let max = maxRangeInput.value;
          updatePriceSlider(min, max, priceSliderGroup);
          minRangeInputRead.value = min;
      });

      maxRangeInput.addEventListener('input', (e) => {
          let min = minRangeInput.value;
          let max = e.target.value;
          updatePriceSlider(min, max, priceSliderGroup);
          maxRangeInputRead.value = max;
      });

      
  });
}

function initFilterLabelsClickable() {
  let filterItems = document.querySelectorAll('.filter-item');

  filterItems.forEach((filterItem) => {
    let filterLabel = filterItem.querySelector('label');

    filterLabel.addEventListener('click', (e) => {
      let input = filterItem.querySelector('input');

      if(input.checked) {
        input.checked = false;
      } else {
        input.checked = true;
      }
    });
  });
}

function initSizeFilterOrder() {
  let sizeList = document.querySelector('.size-list') ? document.querySelector('.size-list') : false;
  let topSizes = ['XXS', 'XS', 'XS/S', 'S', 'M', 'M/L', 'L', 'XL', 'XL/XXL', 'XXL'];
  let ageSizes = ['Micro Preemie', 'Preemie', 'Newborn', 'Newborn-3 Month', '3-6 Month', '6-12 Month', '12-24 Month', '12 Month-4 Years', '2T', '2/3T', '3T', '4', '4-5', '5', '6', '6-7', '7'];
  let ozSizes = ['4 oz', '5 oz', '8 oz'];

  if(sizeList) {
    let sizeItems = document.querySelectorAll('.size-list--item');
    let otherIndex = 0;

    sizeItems.forEach((sizeItem) => {
      let size = sizeItem.querySelector('input').value;
      if(topSizes.includes(size)) {
        let sizeIndex = topSizes.lastIndexOf(size);
        sizeItem.setAttribute('data-top-index', sizeIndex);
      } else if(ageSizes.includes(size)) {
        let sizeIndex = ageSizes.lastIndexOf(size);
        sizeItem.setAttribute('data-age-index', sizeIndex);
      } else if(ozSizes.includes(size)) {
        let sizeIndex = ozSizes.lastIndexOf(size);
        sizeItem.setAttribute('data-oz-index', sizeIndex);
      } else {
        sizeItem.setAttribute('data-other-index', otherIndex);
        otherIndex++;
      }
    });

    let topSizeItems = document.querySelectorAll('.size-list--item[data-top-index]');
    let ageSizeItems = document.querySelectorAll('.size-list--item[data-age-index]');
    let ozSizeItems = document.querySelectorAll('.size-list--item[data-oz-index]');
    let otherSizeItems = document.querySelectorAll('.size-list--item[data-other-index]');
    let runningOrder = 0;

    topSizeItems.forEach((sizeItem, index) => {
      let order = parseInt(sizeItem.getAttribute('data-top-index'));
      sizeItem.style.order = order;
      if(index === topSizeItems.length - 1) {
        runningOrder = topSizeItems.length;
      }
    });

    ageSizeItems.forEach((sizeItem, index) => {
      let order = parseInt(sizeItem.getAttribute('data-age-index'));
      sizeItem.style.order = order + runningOrder;
      if(index === ageSizeItems.length - 1) {
        runningOrder = runningOrder + ageSizeItems.length;
      }
    });

    ozSizeItems.forEach((sizeItem, index) => {
      let order = parseInt(sizeItem.getAttribute('data-oz-index'));
      sizeItem.style.order = order + runningOrder;
      if(index === ozSizeItems.length - 1) {
        runningOrder = runningOrder + ozSizeItems.length;
      }
    });

    otherSizeItems.forEach((sizeItem) => {
      let order = parseInt(sizeItem.getAttribute('data-other-index'));
      sizeItem.style.order = order + runningOrder;
    });
  }
}

function updatePriceSlider(min, max, slider) {

    let priceSlider = slider.querySelector('.price-slider');
    let minRangeInput = slider.querySelector('.min-range');
    let maxRangeInput = slider.querySelector('.max-range');
    let rangeMax = maxRangeInput.getAttribute('max');
    let rangeMin = minRangeInput.getAttribute('min');

    let minPercentPosition = (min / rangeMax) * 100;
    let maxPercentPosition = (max / rangeMax) * 100;

    priceSlider.style.left = minPercentPosition + '%';
    priceSlider.style.right = (100 - maxPercentPosition) + '%';
        
}

// Collection Product Item Carousel
function handleProductItemCarouselScroll(productId) {
  let carousel = document.querySelector('.carousel-wrapper[data-product="' + productId + '"]');
  let items = carousel.querySelectorAll('.carousel-item');
  let scrollWrap = carousel.querySelector('.carousel');
  let scrollWrapWidth = scrollWrap.offsetWidth;
  let scrollWrapScrollLeft = scrollWrap.scrollLeft;
  let scrollWrapScrollRight = scrollWrap.scrollLeft + scrollWrapWidth;
  let carouselNavItems = carousel.querySelectorAll('.carousel-control');

  
  items.forEach((item, index) => {
    let itemWidth = item.offsetWidth;
    let itemOffsetLeft = index === 1 ? item.offsetLeft - 0.5 : item.offsetLeft;
    let itemOffsetRight = index === 1 ? (item.offsetLeft + itemWidth) - 1 : item.offsetLeft + itemWidth;

    if (itemOffsetLeft >= scrollWrapScrollLeft && itemOffsetRight <= scrollWrapScrollRight) {
      item.classList.add('active');
      carouselNavItems[index].classList.add('active');
    } else {
      item.classList.remove('active');
      carouselNavItems[index].classList.remove('active');
    }
  });

}

function handleProductItemCarouselClick(productId, clickedItemIndex) {
  event.preventDefault();

  let carousel = document.querySelector('.carousel-wrapper[data-product="' + productId + '"]');
  let carouselNavItems = carousel.querySelectorAll('.carousel-control');
  let carouselItems = carousel.querySelectorAll('.carousel-item');
  let clickedItem = carouselNavItems[clickedItemIndex];
  let activeNavItem = carousel.querySelector('.carousel-control.active');
  let newIndex = 0;

  if(clickedItem == activeNavItem) return;

  carouselNavItems.forEach((item, index) => {
    if(item == clickedItem) {
      item.classList.add('active');
      newIndex = index;
    } else {
      item.classList.remove('active');
    }
  });

  carouselItems.forEach((item, index) => {
    if(index == newIndex) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });

  carouselItems[newIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
}



function initProductItemOptionSelectors(productId, container) {
  let optionsSelector = container.querySelectorAll('.options-container');

  optionsSelector.forEach(optionSelector => {

    let allOptions = optionSelector.querySelectorAll('.option-item-wrapper');

    allOptions.forEach(option => {
      if(!option.classList.contains('out-of-stock')) { 
        option.addEventListener('click', (e) => {
          e.preventDefault();
          handleOptionSelectorClick(option, allOptions);
          updateQuickviewVariant(productId, container);
        });
      }
    });
  });
}

function updateQuickviewVariant(productId, quickview) {
  let form = document.querySelector('.QuickviewProductForm[data-productid="' + productId + '"]');

  let newSelectedVariant = form.querySelector(`.quickview-variant-select option${form.option1 ? `[data-option1="${form.option1.value}"]` : ''}${form.option2 ? `[data-option2="${form.option2.value}"]` : ''}${form.option3 ? `[data-option3="${form.option3.value}"]` : ''}`);

  form.querySelectorAll('.quickview-variant-select option').forEach((option) => option.selected = false);

  if(newSelectedVariant.dataset.outOfStock == 'true') {
    quickview.querySelector('.QuickviewProductForm__AddToCart').innerHTML = 'Out of Stock';
    quickview.querySelector('.QuickviewProductForm__AddToCart').setAttribute('disabled', 'true');
  } else if(!newSelectedVariant) {
    quickview.querySelector('.QuickviewProductForm__AddToCart').innerHTML = 'Out of Stock';
    quickview.querySelector('.QuickviewProductForm__AddToCart').setAttribute('disabled', 'true');
  } else {
    newSelectedVariant.selected = true;
    quickview.querySelector('.QuickviewProductForm__AddToCart').innerHTML = 'Add to Cart';
    quickview.querySelector('.QuickviewProductForm__AddToCart').removeAttribute('disabled');
  }
}

function handleOptionSelectorClick(selectedOption, allOptions) {
  if(selectedOption.classList.contains('selected')) return;
  allOptions.forEach(option => {
    let label = option.querySelector('label');
    let input = option.querySelector('input');
    if(option === selectedOption) {
      label.classList.add('selected');
      input.checked = true;
    } else {
      label.classList.remove('selected');
    }
  });
}

function updateWishlistVariant(selectedInput) {
  let variantId = selectedInput.value;
  let productId = selectedInput.getAttribute('data-product');
  let wishlistBtn = document.querySelector('.wishlist-btn[data-product-id="' + productId + '"]');
  wishlistBtn.setAttribute('data-variant-id', variantId);
}


// Quickview add to cart 
function initQuickviewAddToCart(productId, quickview) {
  let quickviewProductForm = document.querySelector('.QuickviewProductForm[data-productid="' + productId + '"]');
  let addToCartBtn = quickviewProductForm.querySelector('.QuickviewProductForm__AddToCart');

  addToCartBtn.addEventListener('click', () => {
    let formData = {
    'items': [{
      'id': quickviewProductForm.id.value,
      'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .then(() => {
      openSideCartCustom();
    });
  });
}

function openSideCartCustom() {
  let sideCart = document.querySelector('#sidebar-cart');
  sideCart.ariaHidden = 'false';
  // need to refresh cart

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
  }

function openQuickview(productId) {
  event.preventDefault();
  let quickview = document.querySelector('.quickview-container[data-id="' + productId + '"]');
  quickview.classList.add('active');
  if(quickview.getAttribute('data-init') != 'true') {
    initQuickView(productId, quickview);
    quickview.setAttribute('data-init', 'true');
  }
}

function closeQuickview(productId) {
  let quickview = document.querySelector('.quickview-container[data-id="' + productId + '"]');
  quickview.classList.remove('active');
  }

function initQuickView(productId, quickview) {
  initQuickviewAddToCart(productId, quickview);
  initProductItemOptionSelectors(productId, quickview);
  updateQuickviewVariant(productId, quickview);
}

function initProductCardAddToCart(productId) {
  event.preventDefault();  
  let selectedQuantity = 1;
  let formData = {
  'items': [{
    'id': productId,
    'quantity': selectedQuantity
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .then(() => {
    openSideCartCustom();
  });
}

function getCurrentFilters() {
  let urlParams = {};location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){urlParams[k]=v})
  const filters = [];

  for (const [key, value] of Object.entries(urlParams)) {
    if (key.includes("filter")) {
      filters.push(value.replace(/\+/g, " "));
    }
  }
  return filters;
}

function hideUnavailableProducts(productId) {

  const productItems = document.querySelectorAll(".ProductItem");

  productItems.forEach((productItem) => {
    const optionsContainers = productItem.querySelectorAll(".options-container");
    let shouldHide = false;

    optionsContainers.forEach((optionsContainer) => {
      const outOfStockOptions = optionsContainer.querySelectorAll(".out-of-stock");

      if (outOfStockOptions.length > 0) {
        const filterValues = getCurrentFilters();
        const outOfStockOptionsValues = Array.from(outOfStockOptions).map((option) => option.innerHTML.toString().trim());

        if (filterValues.some((value) => outOfStockOptionsValues.includes(value))) {
          shouldHide = true;
        }
      }
    });

    if (shouldHide) {
      productItem.parentElement.style.display = "none";
    }
  });
}

/* ANCHOR PRODUCT GALLERY */

function initProductGallery() {
  let productImages = document.querySelectorAll('.product-gallery-item');
  let galleryBtns = document.querySelectorAll('.product-gallery-btn');

  let hasColorSwatches = false;
  let productFormOptions = document.querySelector('.ProductForm__Option') ? document.querySelector('.ProductForm__Option') : false;
  if(productFormOptions) {
    let productInputs = productFormOptions.querySelectorAll('.ColorSwatch__Radio') ? productFormOptions.querySelectorAll('.ColorSwatch__Radio') : false;
    if(productInputs.length > 0){
      hasColorSwatches = productInputs.length > 1 ? true : false;
    }
  }

  if(hasColorSwatches) {
    let selectedVariant = productFormOptions.querySelector('.ColorSwatch__Radio:checked');
    updateProductImage(selectedVariant.value);
  }

  productImages.forEach((productImage) => {
    productImage.addEventListener('click', () => {
      openProductGallery(productImage.dataset.index);
    });
  });

  galleryBtns.forEach((galleryBtn) => {
    galleryBtn.addEventListener('click', () => {
      let action = galleryBtn.dataset.action;
      if(action == 'close') {
        closeProductGallery();
      } else if(action == 'open') {
        return;
      } else {
        findNewGalleryIndex(action);
      }
    });
  });
}

function openProductGallery(activeIndex) {
  let productGallerySlidesContainer = document.querySelector('.product-gallery-slides-container');

  productGallerySlidesContainer.classList.add('active');

  document.body.style.overflow = 'hidden';

  changeGalleryImage(activeIndex);
}

function closeProductGallery() {
  let productGallerySlidesContainer = document.querySelector('.product-gallery-slides-container');
  productGallerySlidesContainer.classList.remove('active');

  document.body.style.overflow = 'auto';
}

function changeGalleryImage(activeIndex) {
  let productGallerySlidesContainer = document.querySelector('.product-gallery-slides-container');
  let images = productGallerySlidesContainer.querySelectorAll('.product-gallery-slide');

  images.forEach((image, index) => {
    if(index == activeIndex) {
      image.classList.add('active');
    } else {
      image.classList.remove('active');
    }
  });
}

function findNewGalleryIndex(action) {
  let productGallerySlidesContainer = document.querySelector('.product-gallery-slides-container');
  let images = productGallerySlidesContainer.querySelectorAll('.product-gallery-slide');
  let activeImages = [];
  let activeIndex = 0;

  images.forEach((image, index) => {
    if(!image.classList.contains('hidden')) {
      activeImages.push(index);
    }
    if(image.classList.contains('active')) {
      activeIndex = index;
    }
  });

  if(action == 'next') {
    if(activeIndex == activeImages[activeImages.length - 1]) {
      activeIndex = activeImages[0];
    } else {
      activeIndex = activeImages[activeImages.indexOf(activeIndex) + 1];
    }
  } else {
    if(activeIndex == activeImages[0]) {
      activeIndex = activeImages[activeImages.length - 1];
    } else {
      activeIndex = activeImages[activeImages.indexOf(activeIndex) - 1];
    }
  }

  changeGalleryImage(activeIndex);
}

function initMobileCarousel() {
  let wrapper = document.querySelector('.product-image-gallery-container');
  let carousel = wrapper.querySelector('.product-gallery-mobile-carousel');
  let carouselNavItems = wrapper.querySelectorAll('.product-gallery-carousel-control:not(.hidden)');
  let carouselItems = wrapper.querySelectorAll('.product-gallery-item');
  let activeIndex = 0;
  let firstFound = false;

  carouselItems.forEach((item) => {
    if(!firstFound) {
      if(!item.classList.contains('hidden')) {
        activeIndex = item.dataset.index;
        firstFound = true;
      }
    }
  });

  // check in carousel has scroll event listener
  if(!carousel.dataset.init) {
    carousel.addEventListener('scroll', (e) => {
      carousel.dataset.init = true;
      findCarouselScrollIndex(e);
    });
  }


  carouselNavItems.forEach((carouselNavItem) => {
    if(carouselNavItem.dataset.index == activeIndex) {
      carouselNavItem.classList.add('active');
    } else {
      carouselNavItem.classList.remove('active');
    }

    carouselNavItem.addEventListener('click', (e) => {
      handleMobileCarouselScroll(carouselNavItem.dataset.index, 'click');
    });
  });
}

function findCarouselScrollIndex(e) {
  let carousel = document.querySelector('.product-gallery-mobile-carousel');
  if (!carousel.classList.contains('scrolling')) {
    let carouselItems = carousel.querySelectorAll('.product-gallery-item');
    let activeCarouselItems = [];
    let itemWidth = 0;
    let firstFound = false;

    carouselItems.forEach((item, index) => {
      if(!item.classList.contains('hidden')) {
        if(!firstFound) {
          itemWidth = item.offsetWidth;
          firstFound = true;
        }
        activeCarouselItems.push(index);
      }
    });

    let scrollLeft = carousel.scrollLeft;
    
    let scrollIndex = Math.round(scrollLeft / itemWidth);
    let newIndex = activeCarouselItems[scrollIndex];

    handleMobileCarouselScroll(newIndex, 'scroll');
  } 
}

function handleMobileCarouselScroll(newIndex, action) {
  let wrapper = document.querySelector('.product-image-gallery-container');
  let carousel = wrapper.querySelector('.product-gallery-mobile-carousel');
  let carouselItems = wrapper.querySelectorAll('.product-gallery-item');
  let carouselNavItems = wrapper.querySelectorAll('.product-gallery-carousel-control');
  let activeIndex = 0;

  carouselItems.forEach((item, index) => {
    if(index == newIndex) {
      item.classList.add('active');
      activeIndex = item.dataset.index;
    } else {
      item.classList.remove('active');
    }
  });

  carouselNavItems.forEach((navItem) => {
    if(navItem.dataset.index == activeIndex) {
      navItem.classList.add('active');
      return;
    } else {
      navItem.classList.remove('active');
    }
  });

  if(action == 'click') {
    carousel.classList.add('scrolling');
    carouselItems[newIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
    setTimeout(() => {
      carousel.classList.remove('scrolling');
    }, 1000);
  }
}

function updateProductImage(variant) {
  let galleryWrapper = document.querySelector('.product-image-gallery-container');
  let galleryImages = galleryWrapper.querySelectorAll('.product-gallery-item');
  let carouselControls = galleryWrapper.querySelectorAll('.product-gallery-carousel-control');
  let gallerySlides = document.querySelectorAll('.product-gallery-slide');

  let variantEl = document.querySelector('input[value="' + variant + '"]');
  let isColor = variantEl.classList.contains('ColorSwatch__Radio');

  if(!isColor) {
    return;
  }

  let activeIndex = false;

  galleryImages.forEach((galleryImage, index) => {
    let image = galleryImage.querySelector('img');

    if(image.alt.includes(variant) || image.alt.includes(variant.toLowerCase()) || image.src.includes(variant) || image.src.includes(variant.toLowerCase()) || image.alt.includes('all') || image.alt.includes('All')) {
      galleryImage.classList.remove('hidden');
      carouselControls[index].classList.remove('hidden');
      gallerySlides[index].classList.remove('hidden');
      if(!activeIndex) {
        activeIndex = (index + 1);
      }
    } else {
      galleryImage.classList.add('hidden');
      galleryImage.classList.remove('active');
      carouselControls[index].classList.remove('active');
      carouselControls[index].classList.add('hidden');
      gallerySlides[index].classList.add('hidden');
    }
  });

  changeGalleryImage(activeIndex);
  initMobileCarousel();
}


/* ANCHOR DYNAMIC CARDS CAROUSEL FUNCTIONS  
1. On page load call initDynamicCardsCarousel(container) with the container of the carousel
2. Add class 'dynamic-carousel-wrapper' to div with carousel scroll 
3. Add data-scrolling="false" to the carousel wrapper
4. Add class 'dynamic-carousel-item' to each card in the carousel
5. Add class 'active' to the first card in the carousel
6. Add class 'dynamic-carousel-control' to each control button in the carousel
7. Add data-direction="next" or "prev" to each control button in the carousel

** DO NOT ADD STYLES TO THE DYNAMIC CAROUSEL CLASSES **

Example: see featured-cards.liquid section
*/
function initDynamicCardsCarousel(container) {
  let carousel = container.querySelector('.dynamic-carousel-wrapper');
  let cards = container.querySelectorAll('.dynamic-carousel-item');
  let carouselNavItems = container.querySelectorAll('.dynamic-carousel-control');
  let activeCard = carousel.querySelector('.dynamic-carousel-item.active');

  /*activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });*/

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  carousel.addEventListener('scroll', () => {
    if(carousel.dataset.scrolling === 'false') {
      handleDynamicCardsCarouselScroll(carousel, cards, carouselNavItems);
    }
  });

  carouselNavItems.forEach((navItem) => {
    navItem.addEventListener('click', () => {
      findDynamicCardsCarouselIndex(carousel, cards, navItem.dataset.direction, carouselNavItems);
    });
  });

  window.addEventListener('resize', () => {
    checkDynamicCarouselWidth(carousel, carouselNavItems);
  });
}

function checkDynamicCarouselWidth(carousel, carouselNavItems) {
  let carouselInner = carousel.querySelector('.dynamic-carousel-inner');
  let totalCarouselWidth = carouselInner.offsetWidth;
  let header = carousel.previousElementSibling;

  if(window.innerWidth >= totalCarouselWidth) {
    carousel.style.alignItems = 'center';
    carousel.style.justifyContent = 'center';
    carouselNavItems.forEach((navItem) => {
      navItem.style.display = 'none';
    })
    if(header) {
      header.style.justifyContent = 'center';
      header.style.alignItems = 'center'; 
    }
  } else {
    carousel.style.alignItems = '';
    carousel.style.justifyContent = '';
    carouselNavItems.forEach((navItem) => {
      navItem.style.display = '';
    })
    if(header) {
      header.style.justifyContent = '';
      header.style.alignItems = '';
    }
  }
}

function findDynamicCardsCarouselIndex(carousel, cards, direction, carouselNavItems) {
  let activeCard = carousel.querySelector('.dynamic-carousel-item.active');
  let newIndex = 0;
  let carouselInner = carousel.querySelector('.dynamic-carousel-inner');
  let cardGap = parseInt(window.getComputedStyle(carouselInner).gap);
  let cardsPerView = window.innerWidth / (activeCard.offsetWidth + cardGap);

  // if cardsPerView decimal is greater than 0.9 round up
  if(cardsPerView - Math.floor(cardsPerView) > 0.9) {
    cardsPerView = Math.ceil(cardsPerView);
  } else {
    cardsPerView = Math.floor(cardsPerView);
  }


  let endIndex = cards.length - cardsPerView;

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  cards.forEach((card, index) => {
    if(card == activeCard) {
      card.classList.remove('active');
      if(direction == 'next') {
        newIndex = index + 1;
        if(newIndex == cards.length) {
          newIndex = 0;
        }

        if(newIndex > endIndex) {
          newIndex = 0;
        }
      } else {
        newIndex = index - 1;
        if(newIndex < 0) {
          newIndex = cards.length - 1;
        }

        if(newIndex > endIndex) {
          newIndex = endIndex;
        }
      }
    } 

  })

  cards[newIndex].classList.add('active');
  carousel.dataset.scrolling = true;
  cards[newIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  setTimeout(() => {
    carousel.dataset.scrolling = false;
  }, 1000);
}

function handleDynamicCardsCarouselScroll(carousel, cards, carouselNavItems) {
  let activeCard = carousel.querySelector('.dynamic-carousel-item.active');
  let cardWidth = activeCard.offsetWidth;
  let scrollLeft = carousel.scrollLeft;
  let newIndex = Math.round(scrollLeft / cardWidth);
  let cardsPerView = Math.floor(window.innerWidth / cardWidth);
  let endIndex = cards.length - cardsPerView;

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  if(newIndex > endIndex) {
    newIndex = endIndex;
  } else if(newIndex < 0) {
    newIndex = 0;
  }

  cards.forEach((card, index) => {
    if(index == newIndex) {
      card.classList.add('active');
    } else {
      card.classList.remove('active');
    }
  });
}

/* END DYNAMIC CARDS CAROUSEL FUNCTIONS */

/* ANCHOR PRODUCT CARD FUNCTIONS */
function productCardAddToCart(id) {
  event.preventDefault();
  let button = event.target;
  let buttonText = button.querySelector('.product-card-btn-text');
  buttonText.innerText = 'Adding...';
  button.setAttribute('disabled', 'true');
  button.classList.add('loading');

  let formData = {
    'items': [{
      'id': id,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    return response.json();
  }).catch((error) => {
    console.error('Error:', error);
  }).then(() => {
    buttonText.innerText = 'Added!';
    updateCartCount();
    setTimeout(() => {
      button.classList.remove('loading');
      buttonText.innerText = 'Add to Cart';
      button.removeAttribute('disabled');
    }, 2000);
  });
}

function getProductCardDetails(handle) {
  event.preventDefault()
  let url = window.Shopify.routes.root + 'products/' + handle + '.js';

  fetch(url)
  .then(response => response.json())
  .then(product => {
    openQuickBuy(product);
  });
}

function openQuickBuy(product) {
  let quickBuy = document.querySelector('.quick-buy-container');
  quickBuy.classList.add('active');
  quickBuy.focus({preventScroll: true});
  quickBuy.setAttribute('data-product-id', product.id);

  let body = document.querySelector('body');
  body.style.overflow = 'hidden';

  let productTitle = quickBuy.querySelector('#quick-buy-title');
  productTitle.innerText = product.title;

  let productPrice = quickBuy.querySelector('#quick-buy-price');

  // format prices to add decimals with no trailing zeros
  let price = parseFloat((product.price / 100)).toFixed(2);
  if(price.includes('.00')) {
    price = price.replace('.00', '');
  }
  productPrice.innerText = '$' + price;

  if(product.compare_at_price) {
    let productComparePrice = quickBuy.querySelector('#quick-buy-compare-price');
    let comparePrice = parseFloat((product.compare_at_price / 100)).toFixed(2);
    if(comparePrice.includes('.00')) {
      comparePrice = comparePrice.replace('.00', '');
    }
    productComparePrice.innerText = '$' + comparePrice;
  }

  let productImagesWrapper = quickBuy.querySelector('.quick-buy-product-gallery-images');
  let productGalleryControlsWrapper = quickBuy.querySelector('.quick-buy-gallery-carousel-controls');

  product.media.forEach((media, index) => {
    if(media.media_type == 'image') {
      let imageWrapper = document.createElement('div');
      let image = document.createElement('img');
      image.src = media.src + '&width=600';
      image.alt = media.alt;
      imageWrapper.classList.add('quick-buy-gallery-image');
      imageWrapper.classList.add('quick-buy-gallery-media');
      let control = document.createElement('button');
      control.classList.add('quick-buy-gallery-control');
      control.classList.add('no-btn-style');
      control.setAttribute('aria-label', 'View image ' + (index + 1));
      control.setAttribute('aria-controls', 'quick-buy-gallery-carousel');
      control.setAttribute('role', 'button');
      control.dataset.index = index;
      if(index === 0) {
        image.classList.add('active');
        control.classList.add('active');
      }
      imageWrapper.appendChild(image);
      productImagesWrapper.appendChild(imageWrapper);
      productGalleryControlsWrapper.appendChild(control);
    } else if (media.media_type == 'video') {
      let videoWrapper = document.createElement('div');
      let video = document.createElement('video');
      video.autoplay = false;
      video.controls = true;
      videoWrapper.classList.add('quick-buy-gallery-video');
      videoWrapper.classList.add('quick-buy-gallery-media');
      media.sources.forEach((source) => {
      let sourceItem = document.createElement('source');
      sourceItem.src = source.url;
      sourceItem.type = source.mime_type;
      video.appendChild(sourceItem);
      });
      let control = document.createElement('button');
      control.classList.add('quick-buy-gallery-control');
      control.classList.add('no-btn-style');
      control.dataset.index = index;
      if(index === 0) {
        image.classList.add('active');
        control.classList.add('active');
      }
      videoWrapper.appendChild(video);
      productImagesWrapper.appendChild(videoWrapper);
      productGalleryControlsWrapper.appendChild(control);
    }


  });

  initQuickBuyGalleryCarousel();

  let variantWrapper = quickBuy.querySelector('.quick-buy-form-variants');

  product.options.forEach((option) => {
    let optionContainer = document.createElement('div');
    optionContainer.classList.add('quick-buy-form-variant');
    let heading = document.createElement('h3');
    heading.innerText = option.name;
    heading.classList.add('loulou-h3');
    optionContainer.appendChild(heading);
    let select = document.createElement('div');
    select.classList.add('quick-buy-variant-select');
    select.name = 'option' + option.position;
    select.id = 'option' + option.position;
    select.dataset.option = option.position;


    option.values.forEach((value, index) => {
      let optionWrapper = document.createElement('div');
      let option = document.createElement('input');
      let optionLabel = document.createElement('label');
      optionWrapper.classList.add('quick-buy-variant-option');
      option.type = 'radio';
      option.value = value;
      option.innerText = value;
      optionWrapper.setAttribute('aria-label', value);
      optionWrapper.setAttribute('role', 'button');
      optionWrapper.setAttribute('tabindex', '0');

      if(index === 0) {
        option.checked = true;
      }

      let availableVariants = [];

      product.variants.forEach((variant) => {
        if(variant.option1 == value || variant.option2 == value || variant.option3 == value) {
          if(variant.available){
            availableVariants.push(variant.id);
          }
        }
      });

      if(availableVariants.length == 0) {
        optionWrapper.classList.add('out-of-stock');
      } else {
        option.dataset.availableVariants = availableVariants;
      }

      optionWrapper.appendChild(option);
      optionLabel.innerText = value;
      optionLabel.classList.add('loulou-label');
      optionWrapper.appendChild(optionLabel);
      select.appendChild(optionWrapper);
    });
    optionContainer.appendChild(select);
    variantWrapper.appendChild(optionContainer);
  });

initQuickBuyVariantSelectors(product.variants);

}

function closeQuickBuy() {
  let quickBuy = document.querySelector('.quick-buy-container');
  quickBuy.classList.remove('active');
  let productId = quickBuy.getAttribute('data-product-id');

  // focus back to product card
  let productCard = document.querySelector('.product-card[data-product-id="' + productId + '"]');
  if(productCard){
    productCard.focus();
  }
  quickBuy.removeAttribute('data-product-id');

  let body = document.querySelector('body');
  body.style.overflow = 'unset';

  let productTitle = quickBuy.querySelector('#quick-buy-title');
  productTitle.innerText = '';

  let productPrice = quickBuy.querySelector('#quick-buy-price');
  productPrice.innerText = '';

  let productComparePrice = quickBuy.querySelector('#quick-buy-compare-price');
  productComparePrice.innerText = '';

  let productImagesWrapper = quickBuy.querySelector('.quick-buy-product-gallery-images');
  let productGalleryControlsWrapper = quickBuy.querySelector('.quick-buy-gallery-carousel-controls');
  productImagesWrapper.innerHTML = '';
  productGalleryControlsWrapper.innerHTML = '';

  let variantWrapper = quickBuy.querySelector('.quick-buy-form-variants');
  variantWrapper.innerHTML = '';

  let addToCartBtn = quickBuy.querySelector('.quick-buy-form-btn');
  addToCartBtn.removeAttribute('disabled');
  addToCartBtn.dataset.variantId = '';
  addToCartBtn.dataset.subscriptionId = '';
}

function initQuickBuyGalleryCarousel() {
  let quickBuy = document.querySelector('.quick-buy-container');
  let carousel = quickBuy.querySelector('.quick-buy-carousel');
  let galleryImages = quickBuy.querySelectorAll('.quick-buy-gallery-media');
  let galleryControls = quickBuy.querySelectorAll('.quick-buy-gallery-control');

  galleryControls.forEach((control) => {
    control.addEventListener('click', () => {
      updateQuickbuyCarousel(control.dataset.index, galleryImages, galleryControls, carousel);
    });
  });

  carousel.addEventListener('scroll', () => {
    if(carousel.dataset.scrolling === 'false') {
      findQuickbuyCarouselIndex(carousel, galleryImages, galleryControls);
    }
  });
}

function updateQuickbuyCarousel(activeIndex, images, controls, carousel) {
  images.forEach((image, index) => {
    if(index == activeIndex) {
      image.classList.add('active');
      controls[index].classList.add('active');
    } else {
      image.classList.remove('active');
      controls[index].classList.remove('active');
    }
  });

  carousel.dataset.scrolling = true;
  images[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

  setTimeout(() => {
    carousel.dataset.scrolling = false;
  }, 1000);
}

function findQuickbuyCarouselIndex(carousel, images, controls) {
  let activeImage = carousel.querySelector('.quick-buy-gallery-media.active');
  let activeIndex = 0;
  let imageWidth = activeImage.offsetWidth;
  let scrollLeft = carousel.scrollLeft;
  let newIndex = Math.round(scrollLeft / imageWidth);

  images.forEach((image, index) => {
    if(index == newIndex) {
      image.classList.add('active');
      activeIndex = index;
    } else {
      image.classList.remove('active');
    }
  });

  controls.forEach((control, index) => {
    if(index == activeIndex) {
      control.classList.add('active');
    } else {
      control.classList.remove('active');
    }
  });
}

function initQuickBuyVariantSelectors(variants) {
  let optionWrappers = document.querySelectorAll('.quick-buy-form-variant');

  optionWrappers.forEach((optionWrapper) => {
    let options = optionWrapper.querySelectorAll('.quick-buy-variant-option');

    options.forEach((option, index) => {
      option.addEventListener('click', () => {
        updateQuickBuyVariant(option, variants, options, optionWrappers);
      });
      option.addEventListener('keydown', (e) => {
        if(e.key === 'Enter') {
          updateQuickBuyVariant(option, variants, options, optionWrappers);
        }
      });
      if(option.querySelector('input').checked) {
        if(option.classList.contains('out-of-stock')) {
          let foundMatch = false;
          option.querySelector('input').checked = false;
          options.forEach((option) => {
            if(!foundMatch && !option.classList.contains('out-of-stock')) {
              foundMatch = true;
              let input = option.querySelector('input');
              if(!input.checked) {
                input.checked = true;
              }
            }
          });
        } else {
          updateQuickBuyVariant(option, variants, options, optionWrappers);
        }
      }
    });
  });

  let outOfStockOptions = document.querySelectorAll('.quick-buy-variant-option.out-of-stock');
  let allOptions = document.querySelectorAll('.quick-buy-variant-option');
  if(outOfStockOptions.length === allOptions.length) {
    let addToCartBtn = document.querySelector('.quick-buy-form-btn');
    addToCartBtn.setAttribute('disabled', 'true');
    addToCartBtn.innerText = 'Sold Out';
  }
}

function updateQuickBuyVariant(selectedOption, variants, options, optionWrappers) {
  options.forEach((option) => {
    let input = option.querySelector('input');
    if(option == selectedOption) {
      input.checked = true;
    } else {
      input.checked = false;
    }
  });

  if(optionWrappers.length === 1) {
    let variantId = selectedOption.querySelector('input').dataset.availableVariants;
    updateQuickBuyAddToCart(variantId, variants);
  } else {
    let selectedOptions = [];
    optionWrappers.forEach((optionWrapper) => {
      let selectedOption = optionWrapper.querySelector('.quick-buy-variant-option input:checked');
      selectedOptions.push(selectedOption.value);
    });

    matchVariantToOptions(selectedOptions, variants);
    hideUnavailableOptions(optionWrappers, variants, selectedOption);
  }
}

function hideUnavailableOptions(optionWrappers, variants, selectedOption) {
  let selectedOptions = [];
  optionWrappers.forEach((optionWrapper) => {
    let selectedOption = optionWrapper.querySelector('.quick-buy-variant-option input:checked');
    selectedOptions.push(selectedOption.value);
  })

  let availableVariants = [];
  let unavailableOptions = [];

  variants.forEach((variant) => {
    if(variant.option1 == selectedOptions[0] && variant.option2 == selectedOptions[1] && variant.option3 == selectedOptions[2]) {
      availableVariants.push(variant.id);
    }
  });

  optionWrappers.forEach((optionWrapper) => {
    let options = optionWrapper.querySelectorAll('.quick-buy-variant-option');
    options.forEach((option) => {
      let input = option.querySelector('input');
      if(input.value == selectedOptions[optionWrapper.dataset.option - 1]) {
        if(availableVariants.includes(input.dataset.availableVariants)) {
          option.classList.remove('hidden');
        } else {
          option.classList.add('hidden');
        }
      }
    });
  });
}

function matchVariantToOptions(selectedOptions, variants) {
  let variantId;

  variants.forEach((variant) => {
    if(!variantId) {
      if(selectedOptions.length === 2) {
        if(variant.option1 == selectedOptions[0] && variant.option2 == selectedOptions[1]) {
          variantId = variant.id;
        }
      } else {
        if(variant.option1 == selectedOptions[0] && variant.option2 == selectedOptions[1] && variant.option3 == selectedOptions[2]) {
          variantId = variant.id;
        }
      }
    }
  });

  updateQuickBuyAddToCart(variantId, variants);
}

function updateQuickBuyAddToCart(variantId, variants) {
  let addToCartBtn = document.querySelector('.quick-buy-form-btn');
  let priceEl = document.querySelector('#quick-buy-price');
  let comparePriceEl = document.querySelector('#quick-buy-compare-price');

  let subscriptionId;
  let price;
  let comparePrice;
  let variantAvailable = false;

  variants.forEach((variant) => {
    if(variant.id == variantId) {
      variantAvailable = variant.available;
      if(variant.selling_plan_allocations.length > 0) {
        subscriptionId = variant.selling_plan_allocations[0].selling_plan_id;
        price = variant.selling_plan_allocations[0].price_adjustments[0].price;
        comparePrice = variant.selling_plan_allocations[0].price_adjustments[0].compare_at_price;
      } else {
        subscriptionId = false;
        price = variant.price;
        comparePrice = variant.compare_at_price;
      }
    }
  });

  price = parseFloat((price / 100)).toFixed(2);
  if(price.includes('.00')) {
    price = price.replace('.00', '');
  }
  priceEl.innerText = '$' + price;

  if(comparePrice) {
    comparePrice = parseFloat((comparePrice / 100)).toFixed(2);
    if(comparePrice.includes('.00')) {
      comparePrice = comparePrice.replace('.00', '');
    }
    comparePriceEl.innerText = '$' + comparePrice;
  }

  addToCartBtn.dataset.variantId = variantId;
  addToCartBtn.dataset.subscriptionId = subscriptionId ? subscriptionId : false;

  if(variantAvailable) {
    addToCartBtn.removeAttribute('disabled');
  } else {
    addToCartBtn.setAttribute('disabled', 'true');
  }
  }

  function updateQuickbuyQuantity(action) {
  let quantityInput = document.querySelector('#quick-buy-quantity'); 
  let currentQuantity = parseInt(quantityInput.value);

  if(action == 'increase') {
    quantityInput.value = currentQuantity + 1;
  } else if(action == 'decrease' && currentQuantity > 1) {
    quantityInput.value = currentQuantity - 1;
  }
}

function quickBuyAddToCart() {
  let button = event.target;
  let variantId = button.dataset.variantId;
  let subscriptionId = button.dataset.subscriptionId != 'false' ? button.dataset.subscriptionId : false;
  let quantity = document.querySelector('#quick-buy-quantity').value;

  button.innerText = 'Adding...';
  button.setAttribute('disabled', 'true');
  button.classList.add('loading');

  let formData = subscriptionId ? {
    'items': [{
      'id': variantId,
      'quantity': quantity,
      'selling_plan': subscriptionId
    }]
  } : {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    return response.json();
  }).catch((error) => {
    console.error('Error:', error);
  }).then(() => {
    button.innerText = 'Added to Cart!';
    updateCartCount();
    setTimeout(() => {
      button.innerText = 'Add to Cart';
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      closeQuickBuy();
    }, 2000);
  });
}

/* ANCHOR UPDATE CART COUNT IN HEADER */

function updateCartCount() {
  let cartCount = document.querySelector('.main-header--cart-count');
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    return response.json();
  }).catch((error) => {
    console.error('Error:', error);
  }).then((data) => {
    cartCount.innerText = '(' + data.item_count + ')';
  });
}

/* ANCHOR New Collection Page Functions */
function toggleSortOptions() {
  let sortWrapper = document.querySelector('.sort-wrapper');
  if(sortWrapper.classList.contains('active')) {
    sortWrapper.classList.remove('active');
  } else {
    sortWrapper.classList.add('active');
  }

  document.addEventListener('click', (e) => {
    if(!sortWrapper.contains(e.target)) {
      sortWrapper.classList.remove('active');
    }
  });
}

function toggleFilterOptions(filter) {
  let filterWrapper = document.querySelector('.collection-filter__group--collapsible[data-filter="' + filter + '"]');
  let innerFilter = filterWrapper.querySelector('.filter__group-inner');
  if(filterWrapper.classList.contains('open')) {
    filterWrapper.classList.remove('open');
    innerFilter.setAttribute('aria-expanded', 'false');
    filterWrapper.focus();    
  } else {
    filterWrapper.classList.add('open');
    innerFilter.setAttribute('aria-expanded', 'true');
    let firstFilter = filterWrapper.querySelector('.filter-option');
    innerFilter.focus();
  }
}

function toggleMobileFilter(toggle) {
  let filter = document.querySelector('.filter-wrapper');
  let pageOverlay = document.querySelector('.FilterPageOverlay');
  let body = document.querySelector('body');
  let filterBtn = document.querySelector('.mobile-filter-open');

  if (toggle === 'open') {
    filter.classList.add('active');
    pageOverlay.classList.add('is-visible');
    body.style.overflow = 'hidden';
  } else {
    filter.classList.remove('active');
    pageOverlay.classList.remove('is-visible');
    body.style.overflow = 'auto';
  }

  document.addEventListener('click', (e) => {
    if(!filter.contains(e.target) && !filterBtn.contains(e.target)) {
      filter.classList.remove('active');
      pageOverlay.classList.remove('is-visible');
      body.style.overflow = 'auto';
    }
  });
}